import { render, staticRenderFns } from "./showOwnerRoom.vue?vue&type=template&id=061b8c9f&scoped=true"
import script from "./showOwnerRoom.vue?vue&type=script&lang=js"
export * from "./showOwnerRoom.vue?vue&type=script&lang=js"
import style0 from "./showOwnerRoom.vue?vue&type=style&index=0&id=061b8c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061b8c9f",
  null
  
)

export default component.exports